var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "parking-plan" }, [
    _c(
      "div",
      { staticClass: "parking-plan__floor" },
      [
        _vm.floor && _vm.elements
          ? _c("Canvas", {
              attrs: { floor: _vm.floor, elements: _vm.elements },
              on: {
                clickElement: function ($event) {
                  return _vm.$emit("clickElement", $event)
                },
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "parking-plan__filter" },
      [_c("FilterPlan", { attrs: { filters: _vm.filtersArea } })],
      1
    ),
    _vm._v(" "),
    _vm.floor && _vm.floors && _vm.floors.length
      ? _c("div", { staticClass: "parking-plan__sly-floor" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "parking-plan__sly-floor-list" },
            [
              _c("Sly", {
                attrs: {
                  list: _vm.floors,
                  activeId: _vm.floorId,
                  modify: "is-floor",
                },
                on: { click: _vm.setFloor },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.floor && _vm.floor.number
      ? _c(
          "div",
          {
            staticClass: "parking-plan__fix-floor",
            on: {
              click: function ($event) {
                _vm.floorPopup = true
              },
            },
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.floor.number) + " этаж")]),
            _vm._v(" "),
            _c(
              "svg",
              {
                attrs: {
                  width: "7",
                  height: "14",
                  viewBox: "0 0 7 14",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("g", { attrs: { opacity: "0.4" } }, [
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M0.146447 10.1464C0.341709 9.95118 0.658291 9.95118 0.853554 10.1464L3.5 12.7929L6.14645 10.1464C6.34171 9.95118 6.65829 9.95118 6.85355 10.1464C7.04882 10.3417 7.04882 10.6583 6.85355 10.8536L3.85355 13.8536C3.65829 14.0488 3.34171 14.0488 3.14645 13.8536L0.146447 10.8536C-0.0488154 10.6583 -0.0488154 10.3417 0.146447 10.1464Z",
                      fill: "#2C2925",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M6.85355 3.85355C6.65829 4.04882 6.34171 4.04882 6.14645 3.85355L3.5 1.20711L0.853553 3.85355C0.658291 4.04882 0.341709 4.04882 0.146447 3.85355C-0.0488156 3.65829 -0.0488156 3.34171 0.146447 3.14645L3.14645 0.146447C3.24021 0.0526783 3.36739 0 3.5 0C3.63261 0 3.75979 0.0526783 3.85355 0.146447L6.85355 3.14645C7.04882 3.34171 7.04882 3.65829 6.85355 3.85355Z",
                      fill: "#2C2925",
                    },
                  }),
                ]),
              ]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "parking-plan__popup-floor" },
      [
        _c("transition", { attrs: { name: "fade" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.floorPopup,
                  expression: "floorPopup",
                },
              ],
              staticClass: "parking-plan__popup-floor-inner",
            },
            [
              _c(
                "div",
                {
                  staticClass: "parking-plan__popup-close",
                  on: {
                    click: function ($event) {
                      _vm.floorPopup = false
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "10",
                        height: "10",
                        viewBox: "0 0 10 10",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M0.232333 0.232333C-0.0774444 0.542111 -0.0774444 1.04436 0.232333 1.35414L3.8782 5L0.232333 8.64586C-0.0774444 8.95564 -0.0774444 9.45789 0.232333 9.76767C0.542111 10.0774 1.04436 10.0774 1.35414 9.76767L5 6.1218L8.64586 9.76767C8.95564 10.0774 9.45789 10.0774 9.76767 9.76767C10.0774 9.45789 10.0774 8.95564 9.76767 8.64586L6.1218 5L9.76767 1.35414C10.0774 1.04436 10.0774 0.542111 9.76767 0.232333C9.45789 -0.0774444 8.95564 -0.0774444 8.64586 0.232333L5 3.8782L1.35414 0.232333C1.04436 -0.0774444 0.542111 -0.0774444 0.232333 0.232333Z",
                          fill: "#2C2925",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "parking-plan__popup-floor-content" },
                [
                  _c("Sly", {
                    attrs: {
                      list: _vm.floors,
                      activeId: _vm.floorId,
                      modify: "is-floor",
                    },
                    on: { click: _vm.setFloor },
                  }),
                ],
                1
              ),
            ]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "parking-plan__sly-floor-ttl" }, [
      _c("div", { staticClass: "parking-plan__sly-floor-ttl-item" }, [
        _vm._v("В продаже"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "parking-plan__sly-floor-ttl-item" }, [
        _vm._v("Этаж"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }